import React, { useState } from 'react';
import { Section } from './Section';
import { Gift, ChevronDownIcon, SparklesIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const bonuses = [{
  num: '01',
  title: 'Playlist Curada por Emoción',
  desc: '6 playlists completas con BPM específico por tomo. La música correcta para cada clase sin buscar nada.',
  value: '$12.000',
  emoji: '🎵'
}, {
  num: '02',
  title: 'Ficha de Anamnesis Profesional',
  desc: 'Formulario completo, ficha express, ficha para adultos mayores y consentimiento informado editable. Listo para imprimir o compartir por WhatsApp.',
  value: '$9.000',
  emoji: '📋'
}, {
  num: '03',
  title: 'Guía de Variaciones en 3 Niveles',
  desc: '14 ejercicios clave del sistema en versión Fundacional, Estándar y Avanzada. Para dar la misma clase a cualquier grupo.',
  value: '$8.000',
  emoji: '📐'
}, {
  num: '04',
  title: 'Calendario Anual de Planificación',
  desc: '12 meses organizados semana a semana. Qué tomo, qué clase y qué meta cada semana del año. Sin decidir nunca más qué dar.',
  value: '$10.000',
  emoji: '📅'
}, {
  num: '05',
  title: 'Script de Primera Clase',
  desc: 'Qué decir exactamente en los 5 momentos clave de la primera clase para que el alumno nuevo se quede y pague el mes.',
  value: '$9.000',
  emoji: '🎤'
}, {
  num: '06',
  title: 'Pack de Flyers para WhatsApp e Instagram',
  desc: '18 diseños editables en Canva + calendario de 30 días de contenido listo para publicar. Nunca más la pregunta "¿qué publico hoy?".',
  value: '$8.000',
  emoji: '📱'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <Section className="bg-brand-light !py-8 md:!py-12" data-id="element-19">
      <div className="text-center mb-5 md:mb-8" data-id="element-20">
        <div className="inline-flex items-center gap-1.5 bg-brand-accent/15 text-brand-accent font-bold tracking-widest text-xs px-3 py-1 rounded-full border border-brand-accent/25 mb-3" data-id="element-21">
          <SparklesIcon className="w-3.5 h-3.5" data-id="element-22" />
          INCLUIDOS GRATIS
        </div>
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-1.5" data-id="element-23">
          6 Bonos Estratégicos
        </h2>
        <p className="text-sm md:text-lg text-gray-400 font-medium" data-id="element-24">
          Sin costo extra — incluidos en todas las ofertas
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 mb-5 md:mb-8" data-id="element-25">
        {bonuses.map((bono, i) => {
        const isOpen = openIndex === i;
        return <motion.div key={i} className="rounded-xl border overflow-hidden transition-all duration-200" style={{
          background: isOpen ? 'linear-gradient(135deg, rgba(45,212,191,0.08), rgba(15,23,42,0.6))' : 'rgba(15,23,42,0.5)',
          borderColor: isOpen ? 'rgba(45,212,191,0.35)' : 'rgba(255,255,255,0.07)'
        }} data-id="element-26">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between px-4 py-3 md:px-5 md:py-3.5 text-left focus:outline-none group" data-id="element-27">
                <div className="flex items-center gap-3" data-id="element-28">
                  <span className="text-lg md:text-xl" data-id="element-29">{bono.emoji}</span>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2" data-id="element-30">
                    <span className="text-white font-display font-bold text-sm md:text-base" data-id="element-31">
                      {bono.title}
                    </span>
                    <span className="text-gray-500 text-xs line-through hidden sm:inline" data-id="element-32">
                      {bono.value}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2" data-id="element-33">
                  <span className="bg-brand-accent/20 text-brand-accent text-[10px] font-bold px-2 py-0.5 rounded-full border border-brand-accent/30" data-id="element-34">
                    GRATIS
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-35">
                    <ChevronDownIcon className="w-4 h-4 text-gray-400 group-hover:text-brand-accent transition-colors" data-id="element-36" />
                  </motion.div>
                </div>
              </button>

              <AnimatePresence initial={false} data-id="element-37">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-38">
                    <div className="px-4 pb-3.5 md:px-5 md:pb-4 pt-0 pl-[3.25rem] md:pl-[3.75rem]" data-id="element-39">
                      <span className="text-gray-500 text-xs line-through sm:hidden mb-1 inline-block" data-id="element-40">
                        {bono.value}
                      </span>
                      <p className="text-gray-300 text-sm leading-relaxed" data-id="element-41">
                        {bono.desc}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>

      <div className="bg-gradient-to-r from-brand-accent/15 to-brand-accent/5 border border-brand-accent/30 rounded-xl p-3.5 md:p-4 text-center max-w-3xl mx-auto" data-id="element-42">
        <div className="text-gray-300 text-xs md:text-sm mb-0.5" data-id="element-43">
          VALOR TOTAL DE LOS 6 BONOS{' '}
          <span className="line-through text-gray-500" data-id="element-44">$56.000</span>
        </div>
        <div className="text-xl md:text-2xl font-display font-black text-brand-accent flex items-center justify-center" data-id="element-45">
          <Gift className="w-5 h-5 mr-2" data-id="element-46" /> GRATIS — Incluidos siempre
        </div>
      </div>
    </Section>;
}